import { Link } from 'react-router-dom'

// ** React Imports
import { Fragment, useState } from 'react'
import UILoader from '@components/ui-loader'
import Spinner from '@components/spinner/Loading-spinner'

// ** Custom Components
import NavbarUser from './NavbarUser'
import NavbarBookmarks from './NavbarBookmarks'
import { Button, UncontrolledTooltip } from 'reactstrap'
import ModalClosureAll from '../../../../views/todoClosure'
import { Server, Trello, Tag } from 'react-feather'
import { getUserData } from '../../../../auth/utils'

const ThemeNavbar = props => {
  // ** Props
  const { skin, setSkin, setMenuVisibility } = props
  const [formAdd, setFormAdd] = useState(false)

  const user = getUserData()

  if (!user) {
    return '/login'
  }

  const permisoEx     = user.permission.find((e) => { return e.menu_id === 'EXEOPT' }).menu_enabled === 1
  const permisoGe     = user.permission.find((e) => { return e.menu_id === 'GEROPT' }).menu_enabled === 1
  const permisoCC     = user.permission.find((e) => { return e.menu_id === 'CHAOPT' }).menu_enabled === 1
  const permisoPY     = user.permission.find((e) => { return e.menu_id === 'PAYOPT' }).menu_enabled === 1
  const permisoTdCierres     = user.permission.find((e) => { return e.menu_id === 'TLCOPT' }).menu_enabled === 1

  const handleMostrar = () => {
    setFormAdd(true)
  }

  return (
    <Fragment>
        <div className='bookmark-wrapper d-flex align-items-center'>
          <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
        </div>
        {permisoTdCierres &&
        <div className='d-flex align-items-center' id='all-closures'>
          {(permisoEx || permisoGe || permisoCC || permisoPY) &&
          <Link to="#" onClick={handleMostrar} className="text-secondary">
            <Trello id="icono-trello" size={25}/>
            <UncontrolledTooltip placement='top' target='icono-trello'>
              <span className='fw-bold'>Ver todos los cierres</span>
            </UncontrolledTooltip>
          </Link>
          }
        </div>
        }
        <div className="position-fixed bottom-0 end-0 mb-1 me-5 pe-2">
          <a href={`https://helpdesk.obriencrm.com/index.php?a=add&catid=3&t=${user.token}`} target="_blank" className="btn btn-warning">
            <Tag id="icono-ticket" size={15} /> Reportar Error
          </a>
        </div>
        <NavbarUser skin={skin} setSkin={setSkin} />
        {(permisoEx || permisoGe || permisoCC || permisoPY) &&
        <ModalClosureAll formAdd={formAdd} setFormAdd={setFormAdd} />
        }
    </Fragment>
  )
}

export default ThemeNavbar
